import {Injectable, NgZone} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {State} from '../../reducers';
import * as _ from 'lodash';
import {filter, map, take} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {CoreStore} from './core.store';

export interface BaseActions {
    set: any;
    create: any;
    update: any;
    delete: any;
    load: any;
}

@Injectable()
export class BaseState {

    protected _actions: BaseActions;
    protected _selectors: any;
    protected _initialState: any;
    protected FEATURE_NAME: string;
    protected FeatureActions: CoreStore.Actions;

    constructor(protected _store: Store<State>, protected _zone: NgZone) { }

    set(state = {}) {
        this._store.dispatch(new this._actions.set(state))
    }

    unload() {
        this.set(this._initialState)
    }

    set selected(obj: any) {
        this.set({ selected: obj })
    }

    get selected() {
        return this._store.pipe(
            select(this._selectors.selected),
            filter(i => i !== undefined)
        )
    }

    get success(): Promise<boolean>|Observable<boolean> {
        return this._store.pipe(
            select(this._selectors.success),
            filter(success => success !== undefined),
            take(1)
        ).toPromise()
    }

    public get list(): Observable<any> {
        return this._store.pipe(
            select(this._selectors.data),
            filter(data => !_.isEmpty(data))
        )
    }

    async create(obj) {
        this._store.dispatch(new this._actions.create(obj));
        return this.success
    }

    async load(obj = {}) {
        this._store.dispatch(new this._actions.load(obj));
        return this.success
    }

    async update(obj) {
        this._store.dispatch(new this._actions.update(obj));
        return this.success
    }

    async remove(obj) {
        this._store.dispatch(new this._actions.delete(obj));
        return this.success
    }

    toQueryString(obj) {
        return _.map(obj, (value, key) => key + '=' + value ).join('&')
    }

    async loadv2(obj = {}) {
        this._store.dispatch(new this.FeatureActions.Load(obj))
        return this.success
    }

}


@Injectable()
export class BaseStateV2 {

    protected _selectors: any;
    protected _initialState: any;
    protected FEATURE_NAME: string;
    protected FeatureActions: CoreStore.Actions;

    constructor(protected _store: Store<State>) { }

    set(state = {}) {
        this._store.dispatch(new this.FeatureActions.Set(state))
    }

    unload() {
        this.set(this._initialState)
    }

    set selected(obj: any) {
        this.set({ selected: obj })
    }

    get selected() {
        return this._store.pipe(
            select(this._selectors.selected),
            filter(i => i !== undefined)
        )
    }

    get success(): Promise<boolean>|Observable<boolean> {
        return this._store.pipe(
            select(this._selectors.success),
            filter(success => success !== undefined),
            take(1)
        ).toPromise()
    }

    public get list(): Observable<any> {
        return this._store.pipe(
            select(this._selectors.data),
            filter(data => !_.isEmpty(data))
        )
    }

    async create(obj) {
        this._store.dispatch(new this.FeatureActions.Create(obj));
        return this.success
    }

    async load(obj = {}) {
        this._store.dispatch(new this.FeatureActions.Load(obj));
        return this.success
    }

    async update(obj) {
        this._store.dispatch(new this.FeatureActions.Update(obj));
        return this.success
    }

    async remove(obj) {
        this._store.dispatch(new this.FeatureActions.Delete(obj));
        return this.success
    }

    async removeMultiple(obj) {
        this._store.dispatch(new this.FeatureActions.DeleteMultiple(obj));
        return this.success;
    }

    async paste(obj) {
        this._store.dispatch(new this.FeatureActions.Paste(obj));
        return this.success;
    }

    async move(obj) {
        this._store.dispatch(new this.FeatureActions.Move(obj));
    }

    toQueryString(obj) {
        return _.map(obj, (value, key) => key + '=' + value ).join('&')
    }

    existsWith(attributes) {
        return this.list.pipe(
            map(data => _.filter(data, (item) => _.isMatch(item, attributes)))
        )
    }

}
